const rand = (min, max) => {
  return Math.floor((Math.random() * (max - min + 1)) + min)
}

export class ParticlePart {
  constructor (data) {
    this.ctx = data.ctx
    this.cw = data.cw
    this.ch = data.ch
    this.reset({ images: data.images, isBigPart: data.isBigPart })
  }

  reset (data) {
    const randEffect = rand(0, 3)

    if (data.cw || data.ch) {
      this.cw = data.cw
      this.ch = data.ch
    }

    // some of the parts need to be bigger then other
    this.isBigPart = this.isBigPart ? this.isBigPart : data.isBigPart
    this.startRadius = this.isBigPart ? rand(20, 25) : rand(5, 15)
    this.radius = this.startRadius
    // adding elongation for smaller parts
    this.randRadius = randEffect && this.radius <= 12 ? rand(0, 10) : 0
    // rand images for parts
    this.part = randEffect || this.isBigPart ? data.images[1] : data.images[0]
    // rand where parts need to appear
    this.x = rand(0, this.cw) - 3
    this.y = rand(0, this.ch)
    // for angle calculation
    this.xPrevious = this.x
    this.yPrevious = this.y
    // something like speed
    this.vx = 0
    this.vy = 0
    // alpha for parts disappearing
    this.startAlpha = rand(40, 100) / 100
    this.alpha = 0
    // for parts smooth appearing
    this.previousAlpha = 0
    // for parts life reduction
    this.decayRate = 0.05
    // speed by y axis
    this.ySpeed = rand(0, 5) > 0 ? 10 : -rand(0, 8)
    // speed correction
    this.speedDecr = 0.01
    // parts life cycle parametr
    this.startLife = 100
    this.life = this.startLife
  }

  update (data) {
    this.vx += (rand(-100, 90)) / 20000
    this.vy -= this.ySpeed / rand(10000, 25000)
    this.x += this.vx
    this.y += this.vy

    if (this.previousAlpha < this.startAlpha) {
      this.alpha = this.previousAlpha += 0.01
    } else {
      this.alpha = this.startAlpha * (this.life / this.startLife)
      this.life -= this.decayRate
    }

    this.ySpeed -= this.speedDecr

    // reset when part life is done or the particle flew off the screen
    if (this.x > this.cw + this.radius || this.x < -this.radius ||
      this.y > this.ch + this.radius || this.y < -this.radius ||
      this.life <= this.decayRate || data.resetParts
    ) {
      this.reset({ images: data.images, cw: data.cw, ch: data.ch })
    }
  }

  render (ctx) {
    let rotationAngle = 0

    if (this.xPrevious !== this.x) {
      rotationAngle = Math.atan(-(this.x - this.xPrevious) / (this.y - this.yPrevious))
    }

    ctx.save()
    ctx.translate(this.x + this.radius, this.y + this.radius)
    ctx.globalAlpha = this.alpha
    ctx.rotate(rotationAngle)
    ctx.translate(-this.radius / 2, -this.radius / 2)
    ctx.drawImage(this.part, 0, 0, this.radius, this.radius + this.randRadius)
    ctx.restore()
  }
}
